export { default as getDetail } from './getDetail';
export { default as getDiscountLabel } from './getDiscountLabel';
export { default as getDistanceLabel } from './getDistanceLabel';
export { default as getPriceLabel } from './getPriceLabel';



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/helpers/index.js